import { defineFakeRoute } from 'vite-plugin-fake-server/client';

const rolesInfo: any = {
  // 企服运营
  1000031743: [
    {
      moduleId: 6341236,
      parentId: 6341200,
      moduleName: '运营位管理',
      moduleCode: 'bx_manage_operation_manage',
      moduleIcon: '',
      sort: 1,
      badge: 0,
      parent: null,
      hidden: 'N',
      helpUrl: '222',
      checkStatus: null,
      childModules: [
        {
          moduleId: 6341238,
          parentId: 6341236,
          moduleName: '运营位-编辑',
          moduleCode: 'operation.edit',
          moduleIcon: '',
          sort: 2,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6341239,
          parentId: 6341236,
          moduleName: '运营位-保存',
          moduleCode: 'operation.save',
          moduleIcon: '',
          sort: 3,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6341240,
          parentId: 6341236,
          moduleName: '运营位-提交审核',
          moduleCode: 'operation.submitReview',
          moduleIcon: '',
          sort: 4,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351430,
          parentId: 6341236,
          moduleName: '运营位-UI展示-查看',
          moduleCode: 'operation.uiView',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
      ],
    },
  ],
  // 企服研发
  1000031744: [
    {
      moduleId: 6341236,
      parentId: 6341200,
      moduleName: '运营位管理',
      moduleCode: 'bx_manage_operation_manage',
      moduleIcon: '',
      sort: 1,
      badge: 0,
      parent: null,
      hidden: 'N',
      helpUrl: '222',
      checkStatus: null,
      childModules: [
        {
          moduleId: 6341237,
          parentId: 6341236,
          moduleName: '运营位-创建',
          moduleCode: 'operation.create',
          moduleIcon: '',
          sort: 1,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6341262,
          parentId: 6341236,
          moduleName: '运营位-添加拓展属性',
          moduleCode: 'operation_add_extention',
          moduleIcon: '',
          sort: 1,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6341238,
          parentId: 6341236,
          moduleName: '运营位-编辑',
          moduleCode: 'operation.edit',
          moduleIcon: '',
          sort: 2,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6341239,
          parentId: 6341236,
          moduleName: '运营位-保存',
          moduleCode: 'operation.save',
          moduleIcon: '',
          sort: 3,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351431,
          parentId: 6341236,
          moduleName: '运营位-UI展示-图片使用说明-编辑',
          moduleCode: 'operation_img_desc_edit',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351430,
          parentId: 6341236,
          moduleName: '运营位-UI展示-查看',
          moduleCode: 'operation.uiView',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351421,
          parentId: 6341236,
          moduleName: '运营位-基础信息-查看',
          moduleCode: 'operation_baseinfo_view',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351435,
          parentId: 6341236,
          moduleName: '运营位-UI展示-运营内容扩展属性-key-编辑',
          moduleCode: 'operation_contentext_key_edit',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351437,
          parentId: 6341236,
          moduleName: '运营位-投放周期-查看',
          moduleCode: 'operation_launch_view',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351439,
          parentId: 6341236,
          moduleName: '运营位-投放内容-查看',
          moduleCode: 'operation_content_view',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351419,
          parentId: 6341236,
          moduleName: '运营位-查看',
          moduleCode: 'operation_view',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351429,
          parentId: 6341236,
          moduleName: '运营位-基础信息-编辑',
          moduleCode: 'operation_baseinfo_edit',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
      ],
    },
  ],
  // 企服审核
  1000031745: [
    {
      moduleId: 6341236,
      parentId: 6341200,
      moduleName: '运营位管理',
      moduleCode: 'bx_manage_operation_manage',
      moduleIcon: '',
      sort: 1,
      badge: 0,
      parent: null,
      hidden: 'N',
      helpUrl: '222',
      checkStatus: null,
      childModules: [
        {
          moduleId: 6341241,
          parentId: 6341236,
          moduleName: '运营位-审核',
          moduleCode: 'operation.review',
          moduleIcon: '',
          sort: 5,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '222222',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6341242,
          parentId: 6341236,
          moduleName: '运营位-发布',
          moduleCode: 'operation_publish',
          moduleIcon: '',
          sort: 6,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351430,
          parentId: 6341236,
          moduleName: '运营位-UI展示-查看',
          moduleCode: 'operation.uiView',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351421,
          parentId: 6341236,
          moduleName: '运营位-基础信息-查看',
          moduleCode: 'operation_baseinfo_view',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351437,
          parentId: 6341236,
          moduleName: '运营位-投放周期-查看',
          moduleCode: 'operation_launch_view',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351439,
          parentId: 6341236,
          moduleName: '运营位-投放内容-查看',
          moduleCode: 'operation_content_view',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351419,
          parentId: 6341236,
          moduleName: '运营位-查看',
          moduleCode: 'operation_view',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
      ],
    },
  ],
  // BX管理员
  1000031746: [
    {
      moduleId: 6341236,
      parentId: 6341200,
      moduleName: '运营位管理',
      moduleCode: 'bx_manage_operation_manage',
      moduleIcon: '',
      sort: 1,
      badge: 0,
      parent: null,
      hidden: 'N',
      helpUrl: '222',
      checkStatus: null,
      childModules: [
        {
          moduleId: 6341237,
          parentId: 6341236,
          moduleName: '运营位-创建',
          moduleCode: 'operation.create',
          moduleIcon: '',
          sort: 1,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6341262,
          parentId: 6341236,
          moduleName: '运营位-添加拓展属性',
          moduleCode: 'operation_add_extention',
          moduleIcon: '',
          sort: 1,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6341238,
          parentId: 6341236,
          moduleName: '运营位-编辑',
          moduleCode: 'operation.edit',
          moduleIcon: '',
          sort: 2,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6341239,
          parentId: 6341236,
          moduleName: '运营位-保存',
          moduleCode: 'operation.save',
          moduleIcon: '',
          sort: 3,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6341240,
          parentId: 6341236,
          moduleName: '运营位-提交审核',
          moduleCode: 'operation.submitReview',
          moduleIcon: '',
          sort: 4,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6341241,
          parentId: 6341236,
          moduleName: '运营位-审核',
          moduleCode: 'operation.review',
          moduleIcon: '',
          sort: 5,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '222222',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6341242,
          parentId: 6341236,
          moduleName: '运营位-发布',
          moduleCode: 'operation_publish',
          moduleIcon: '',
          sort: 6,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351431,
          parentId: 6341236,
          moduleName: '运营位-UI展示-图片使用说明-编辑',
          moduleCode: 'operation_img_desc_edit',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351430,
          parentId: 6341236,
          moduleName: '运营位-UI展示-查看',
          moduleCode: 'operation.uiView',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351433,
          parentId: 6341236,
          moduleName: '运营位-UI展示-运营位扩展属性-key-编辑',
          moduleCode: 'operation_extention_key_edit',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351421,
          parentId: 6341236,
          moduleName: '运营位-基础信息-查看',
          moduleCode: 'operation_baseinfo_view',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351432,
          parentId: 6341236,
          moduleName: '运营位-UI展示-图片URL-编辑',
          moduleCode: 'operation_img_value_edit',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351435,
          parentId: 6341236,
          moduleName: '运营位-UI展示-运营内容扩展属性-key-编辑',
          moduleCode: 'operation_contentext_key_edit',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351434,
          parentId: 6341236,
          moduleName: '运营位-UI展示-运营位扩展属性-value-编辑',
          moduleCode: 'operation_extention_value_edit',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351437,
          parentId: 6341236,
          moduleName: '运营位-投放周期-查看',
          moduleCode: 'operation_launch_view',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351436,
          parentId: 6341236,
          moduleName: '运营位-UI展示-其他-编辑',
          moduleCode: 'operation_ui_other_edit',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351440,
          parentId: 6341236,
          moduleName: '运营位-投放内容-编辑',
          moduleCode: 'operation_content_edit',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351428,
          parentId: 6341236,
          moduleName: '运营位-下架',
          moduleCode: 'operation_down',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351439,
          parentId: 6341236,
          moduleName: '运营位-投放内容-查看',
          moduleCode: 'operation_content_view',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351438,
          parentId: 6341236,
          moduleName: '运营位-投放周期-编辑',
          moduleCode: 'operation_launch_edit',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351419,
          parentId: 6341236,
          moduleName: '运营位-查看',
          moduleCode: 'operation_view',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
        {
          moduleId: 6351429,
          parentId: 6341236,
          moduleName: '运营位-基础信息-编辑',
          moduleCode: 'operation_baseinfo_edit',
          moduleIcon: '',
          sort: 8,
          badge: 0,
          parent: null,
          hidden: 'N',
          helpUrl: '',
          checkStatus: null,
          childModules: [],
        },
      ],
    },
  ],
};

export default defineFakeRoute([
  {
    url: '/o-apis-example/mock/dev-basp-user/indexModule/queryMenus',
    timeout: 10,
    method: 'get',
    response: ({ query }) => {
      const roleId = query.roleId as string;
      return {
        succ: 'ok',
        msg: null,
        result: rolesInfo[roleId],
      };
    },
  },
]);
